// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper--GacpG calderLC--1nri-"};


//////////////////
// WEBPACK FOOTER
// ./components/App/styles.css
// module id = 1155
// module chunks = 2